/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./bootstrap');

import 'lazysizes';
import { gsap } from 'gsap';
import { Draggable } from "gsap/Draggable";
import SplitText from './gsap-bonus/SplitText';
import { debounce } from 'lodash';
import Router from './router';
import store from './store';

import Swiper from 'swiper';
import Vue from 'vue';

require('./components/story-settings-component');
require('./components/story-intro-component');
require('./components/story-component');
require('./components/sound-component');

gsap.registerPlugin(Draggable);

const App = new Vue({
    el: '#app',
    delimiters: ['${', '}'],

    data() {
        return {
            router: {
                currentSection: null,
                instance: null,
                prefetch: true
            },
            firstLoad: true,
            pageLoad: false,
            swiper: null,
            menuAnimation: null,
            showNavigation: false,
            showInfo: false,
            minPreloadDelay: 1,
            preloadDelayFinished: false,
            preloadDone: false,
            settings: store.settings,
            stories: store.stories,
            store: store,
            activeStory: 0,
            backgrounds: [
                '/media/images/backgrounds/1.jpg',
                '/media/images/backgrounds/2.jpg',
                '/media/images/backgrounds/3.jpg',
                '/media/images/backgrounds/4.jpg',
                '/media/images/backgrounds/5.jpg',
            ],
            turnDeviceScreen: false,
            preloadScreen: true,
            swipeEvent: null,
            showStorySettings: false,
            elements: null,
            soundPart: 0,
        };
    },

    watch: {
        isMobile: function (value) {
            EventBus.$emit('is-mobile-changed');
        },
        isTablet: function (value) {
            EventBus.$emit('is-tablet-changed');
        },
        showNavigation: function (visibile) {
            EventBus.$emit('navigation-state-changed', visibile);

            const dir = visibile ? 1 : -1;
            this.menuAnimation.setDirection(dir);
            this.menuAnimation.play();
            
            this.$nextTick(() => {
               this.swiper.update(); 
            });
        }
    },

    mounted() {
        this.initBook();

        // Prepare router.
        this.router = new Router({
            instance: this,
            prefetch: true,
            section: this.$el.dataset.initialSection,
            ignoreComponents: [
                'footer-component',
                'navigation-component',
                'language-selector'
            ]
        });

        var retrievedObject = localStorage.getItem("settings");
        this.settings = JSON.parse(retrievedObject);
        if (this.settings) {
            this.settings.animal = this.settings.animal.toLowerCase();
        }

        const homepageCheck = function() {
            var check = false;
            if (document.location.pathname === "/") {
                check = true;
            }
            return check;
        }

        if (!this.settings && !homepageCheck()) {
            window.location = '/';
            return;
        }

        this.preload();

        window.addEventListener('resize', this.onWindowResize);

        if(this.$el.querySelector(".swipe-container")) {
            this.setDraggableContainer()
        }

        this.menuAnimation = lottie.loadAnimation({
            container: document.getElementById('menu-icon'), // Required
            path: '/media/data/menu-icon.json', // Required
            renderer: 'svg', // Required
            loop: false, // Optional
            autoplay: false, // Optional
            name: "Menu Icon", // Name for future reference. Optional.
        });

    },

    methods: {
        initSwiper() {
            if (this.swiper) {
                this.swiper.update();
                return;
            }

            this.swiper = new Swiper('#swiper', {
                direction: 'vertical',
                loop: true,
                loopAdditionalSlides: 0,
                loopedSlides: 5,
                slidesPerView: 'auto',
                initialSlide: 0,
                // centeredSlides: true,
                slideToClickedSlide: true,
                speed: 500,
                // spaceBetween: 20,
            });
    
            this.swiper.on('slideChange', () => {
                console.log('Index change: ' + this.swiper.realIndex);
                if (this.swiper.realIndex !== this.store.currentStoryIndex) {
                    this.goToStoryFromMenu(this.swiper.realIndex);
                }
            });
        },

        initBook() {
            const book = document.getElementById('book');
            if (book) {
                this.book = new BookBlock(book, {
                    onEndFlip : function(old, page, isLimit) {
                        EventBus.$emit('story-part:show-' + (parseInt(page) + 1));
                        console.log('story-part:show-' + (parseInt(page) + 1));
                    },
                });
            }
        },

        preload() {
            // Reset values (when called after a page transition)
            this.preloadDone = false;
            this.preloadDelayFinished = false;

            // Create a minimal delay
            setTimeout(() => {
                this.preloadDelayFinished = true;
                this.start();
            }, this.minPreloadDelay * 1000);
            
            // Preload all data-src elements.
            Vue.nextTick(() => {
                const images = [...document.querySelectorAll('[data-src]')];
                const total = images.length;
                var preloader = require('preloader');
                var loader = preloader({
                    xhrImages: true
                });
    
                if (total < 1) {
                    this.preloadDone = true;
                    this.start();
                    return;
                }
    
                loader.on('complete', () => {
                    for (let index = 0; index < total; index++) {
                        const image = images[index];
                        const url = loader.get(image.dataset.src);
                        console.log(url.src);
                        image.src = url.src;
                    }
                    
                    this.preloadDone = true;
                    this.start();
                });
                
                // const total = images.length;
                for (let index = 0; index < total; index++) {
                    const image = images[index];
                    loader.add(image.dataset.src);
                }
    
                loader.load();
            });

            // Preload all data-src elements.
            Vue.nextTick(() => {
                const images = [...document.querySelectorAll('[data-image-src]')];
                console.log(images);
                const total = images.length;
                var preloader = require('preloader');
                var loader = preloader({
                    xhrImages: false
                });
    
                if (total < 1) {
                    this.preloadDone = true;
                    return;
                }
    
                loader.on('complete', () => {
                    for (let index = 0; index < total; index++) {
                        const image = images[index];
                        const url = loader.get(image.dataset.imageSrc);
                        if (!image.classList.contains('loaded')) {
                            image.src = url.src;
                            image.classList.add('loaded');
                        }
                    }
                    
                    this.preloadDone = true;
                });
                
                // const total = images.length;
                for (let index = 0; index < total; index++) {
                    const image = images[index];
                    loader.add(image.dataset.imageSrc);
                }
    
                loader.load();
            });
        },

        start() {
            if (this.preloadDelayFinished && this.preloadDone) {
                this.preloadScreen = false;
                this.pageLoad = false;
                console.log('Show');
                EventBus.$emit('story-part:show-1');
            }
        },

        checkSettings(url) {
            if (gtag !== undefined) {
                gtag('event', 'start_screen_start', {
                    'event_label': 'User Swiped to start',
                    'event_category': 'Application Start Swipe',
                    'non_interaction': true
                });
            }
              
            if (localStorage.getItem('settings')) {
                page(url);
                return;
            }

            this.showStorySettings = true;
            // EventBus.$emit('play-sound', ['menu01']);

        },

        setDraggableContainer() {
            var swipeUrl = this.$el.querySelector(".swipe-container").dataset.swipeUrl;
            var D = document.createElement('div');
            var self = this;
            this.swipeEvent = Draggable.create(D, {
                type:'y',
                lockAxis : true ,
                trigger:this.$el.querySelector(".swipe-container"),
                onDragEnd:function(){
                    if(this.getDirection("start") == "up") {
                        self.checkSettings(swipeUrl)
                    }
                }
            });
        },

        slideBeforeEnter(el) {
            // console.log(`rect(0, ${ window.innerWidth }px, ${ window.innerHeight }px, 0)`);
            // gsap.set(el, {
            //     clip: `rect(0, ${ window.innerWidth }px, ${ 0 }px, 0)`,
            // });
        },

        slideEnter(el, done) {
            // const box = document.getElementById('page-wrapper').getBoundingClientRect();
            // setTimeout(() => {
            //     gsap.to(el, {
            //         duration: 1,
            //         ease: 'power2.easeOut',
            //         onComplete: done,
            //         clip: `rect(0, ${ box.width }px, ${ box.height }px, 0)`,
            //     });
            // }, 100);
        },

        slideTransitionBeforeEnter(el) {
            const box = document.getElementById('page-wrapper').getBoundingClientRect();
            console.log(`rect(0px, ${ window.innerWidth }px, ${ window.innerHeight }px, 0px)`);
            gsap.set(el, {
                clip: `rect(${ box.height }px, ${ box.width }px, ${ box.height }px, 0px)`,
            });
            // console.log('Before enter');
            // const loader = el.querySelector('.story-settings-overlay__loader');

            // gsap.set(el, {
            //     y: '100%',
            //     transformOrigin: 'bottom center'
            // });

            // gsap.set(loader, {
            //     y: '-100%',
            //     transformOrigin: 'top center'
            // });
        },

        slideTransitionEnter(el, done) {
            const box = document.getElementById('page-wrapper').getBoundingClientRect();
            setTimeout(() => {
                gsap.to(el, {
                    duration: 0.8,
                    ease: 'power2.easeOut',
                    onComplete: done,
                    clip: `rect(${ 0 }px, ${ box.width }px, ${ box.height }px, 0px)`,
                });
            }, 100);

            // const loader = el.querySelector('.story-settings-overlay__loader');

            // gsap.to(el, {
            //     duration: 0.8,
            //     y: '0%',
            //     transformOrigin: 'bottom center',
            //     onComplete: done
            // });

            // gsap.to(loader, {
            //     duration: 0.8,
            //     y: '0%',
            //     transformOrigin: 'top center',
            //     onComplete: done
            // });
        },

        slideTransitionBeforeLeave(el) {
            const box = document.getElementById('page-wrapper').getBoundingClientRect();
            gsap.set(el, {
                clip: `rect(${ 0 }px, ${ box.width }px, ${ box.height }px, 0px)`,
            });
        },

        slideTransitionLeave(el, done) {
            const box = document.getElementById('page-wrapper').getBoundingClientRect();
            setTimeout(() => {
                gsap.to(el, {
                    duration: 0.8,
                    ease: 'power2.easeOut',
                    onComplete: done,
                    clip: `rect(${ 0 }px, ${ box.width }px, ${ 0 }px, 0px)`,
                });
            }, 100);
        },

        slideBeforeLeave(el) {
            gsap.set(['.homepage-content h3', '.homepage-content p'], { autoAlpha: 0 });
            gsap.set(['.swipe-next', '.homepage-illustrator'], { autoAlpha: 0 });


            const split = this.$el.querySelector('.homepage-content h1');
            if (split) {
                console.log(split);
                this.splitTextReveal(split);
            }
            // const box = document.getElementById('page-wrapper').getBoundingClientRect();
            // gsap.set(el, {
            //     clip: `rect(0px, ${ box.width }px, ${ box.height }px, 0px)`,
            // });
        },

        slideLeave(el, done) {
            console.log('slideLeave');
            // const box = document.getElementById('page-wrapper').getBoundingClientRect();
            gsap.to(el, {
                duration: 0.8,
                onComplete: done,
                // clip: `rect(0px, ${ box.width }px, ${ 0 }px, 0px)`,
                autoAlpha: 0
            });

            const split = this.$el.querySelector('.homepage-content h1');

            const tl = gsap.timeline({delay: 1});
            tl.to('.homepage-content h3', {
                duration: 0.6,
                autoAlpha: 1
            });
            tl.call(() => {
                const split = this.$el.querySelector('.homepage-content h1');
                if (split) {
                    // gsap.to(el, { duration: 1, opacity: 1, ease: "power2.out" });
                    gsap.to(this.splitLinesInner, { translateY: `0%`, duration: 1, opacity: 1, stagger: 0.2, ease: "power2.out" });
                }
            });
            tl.to('.homepage-content p', {
                duration: 0.6,
                autoAlpha: 1,
            }, split ? 2 : 0.5);

            tl.to(['.swipe-next', '.homepage-illustrator'], {
                duration: 0.6,
                autoAlpha: 1,
            }, split ? 3 : 1);
        },

        splitLines(el) {
            const selector = el;
            this.split = new SplitText(selector, {
                type: 'lines',
                linesClass: 'split-line'
            });

            for (let index = 0; index < this.split.lines.length; index++) {
                const line = this.split.lines[index];
                let inner = line.innerHTML;
                inner = `<div class="split-line__inner">${inner}</div>`;
                line.innerHTML = inner;
                line.style.overflow = 'hidden';
            }

            this.splitLinesInner = el.querySelectorAll('.split-line__inner')
            gsap.set(this.splitLinesInner, { translateY: `100%`, opacity: 0 });

        },

        splitTextReveal(el) {
            this.splitLines(el);
            window.addEventListener('resize', this.splitTextReveal.resize);
        },
        
        menuBeforeEnter(el) {
            const menuContent = el.querySelector('.menu-overlay__content-container')
            const bgHolder = el.querySelector('.visual-bg-holder');

            gsap.set(menuContent, {opacity: 0});

            console.log(`rect(0px, ${ window.innerWidth }px, ${ window.innerHeight }px, 0px)`);
            gsap.set(bgHolder, {
                clip: `rect(0px, ${ window.innerWidth }px, ${ 0 }px, 0px)`,
            });
        },

        menuEnter(el, done) {
            const menuContent = el.querySelector('.menu-overlay__content-container');
            const bgHolder = el.querySelector('.visual-bg-holder');
            this.initSwiper();
            console.log(this.store.currentStoryIndex);
            this.swiper.slideTo(this.store.currentStoryIndex, 0, false)
            setTimeout(() => {
                gsap.to(el, { duration: 1, onComplete: done })
                gsap.to(menuContent, {opacity: 1, duration: 1, delay: 0.4})
                gsap.to(bgHolder, {
                    duration: 1,
                    ease: 'power2.easeOut',
                    clip: `rect(0, ${ window.innerWidth }px, ${ window.innerHeight }px, 0)`,
                });
            }, 100);
        },

        menuLeave(el, done) {
            const menuContent = el.querySelector('.menu-overlay__content-container');
            const bgHolder = el.querySelector('.visual-bg-holder');

            gsap.to(menuContent, {opacity: 0, duration: 0.8 })
            gsap.to(bgHolder, {
                duration: 1,
                delay: 0.2,
                onComplete: done,
                ease: 'power2.easeOut',
                clip: `rect(0, ${ window.innerWidth }px, ${ 0 }px, 0)`,
            });
        },

        /**
         * Raised when the client window is resizing.
         *
         * @return {Void}
         */
        onWindowResize: debounce(() => {
            EventBus.$emit('window-resize');
        }, 150),

        detectMobile() {
            this.isMobile = window.innerWidth <= 768;
            this.isTablet = window.innerWidth <= 1024;
            console.log(`Is Mobile: ${this.isMobile}`);
        },

        goToStory(index) {
            window.location = `/stories/story-${index + 1}-intro`
        },

        goToStoryFromMenu(index) {
            const block = [
                '/stories/1',
                '/stories/2',
                '/stories/3',
                '/stories/4',
                '/stories/5',
            ];

            const path = window.location.pathname;

            if (block.indexOf(path) > -1 && this.store.currentStoryIndex == index) {
                return;
            }

            console.log(path);
            this.router.setTransition('from-menu');
            page(`/stories/story-${index + 1}-intro`);
        }
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onWindowResize);
    }
});
